import React from 'react';
import { Wallet, DollarSign, TrendingUp } from 'lucide-react';

const CurrencyOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  supportedCurrencies,
  currencyRates
}) => {
  
  // Получение символа выбранной валюты
  const getCurrencySymbol = () => {
    const currency = supportedCurrencies.find(c => c.id === formData.currency);
    return currency ? currency.symbol : formData.currency;
  };
  
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Wallet className="w-5 h-5 mr-2 text-blue-500" />
        Доходы и возможности
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Ежемесячный доход в рублях */}
        <div>
          <label htmlFor="monthlyIncomeRUB" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ежемесячный доход (₽)
          </label>
          <div className="relative mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">₽</span>
            </div>
            <input
              type="text"
              id="monthlyIncomeRUB"
              name="monthlyIncomeRUB"
              value={formData.monthlyIncomeRUB}
              onChange={handleInputChange}
              className={`form-input pl-7 w-full ${errors.monthlyIncomeRUB ? 'input-error' : ''}`}
              placeholder="Введите доход в рублях"
            />
          </div>
          {errors.monthlyIncomeRUB && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.monthlyIncomeRUB}
            </p>
          )}
        </div>

        {/* Наличие дохода в иностранной валюте */}
        <div className="self-end">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasIncomeInForeignCurrency"
              checked={formData.hasIncomeInForeignCurrency}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              У меня есть доход в {formData.currency}
            </span>
          </label>
        </div>

        {/* Доход в валюте кредита (если включено) */}
        {formData.hasIncomeInForeignCurrency && (
          <div className="col-span-full">
            <label htmlFor="monthlyIncomeForeign" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Ежемесячный доход в {formData.currency}
            </label>
            <div className="relative mt-1">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 sm:text-sm">{getCurrencySymbol()}</span>
              </div>
              <input
                type="text"
                id="monthlyIncomeForeign"
                name="monthlyIncomeForeign"
                value={formData.monthlyIncomeForeign}
                onChange={handleInputChange}
                className={`form-input pl-7 w-full ${errors.monthlyIncomeForeign ? 'input-error' : ''}`}
                placeholder={`Введите доход в ${formData.currency}`}
              />
            </div>
            {errors.monthlyIncomeForeign && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.monthlyIncomeForeign}
              </p>
            )}
          </div>
        )}
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <TrendingUp className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Рекомендация по валютной ипотеке
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              {formData.hasIncomeInForeignCurrency 
                ? `Наличие дохода в ${formData.currency} снижает валютные риски по ипотеке, поскольку часть дохода защищена от колебаний курса.` 
                : `Отсутствие дохода в ${formData.currency} увеличивает валютные риски. Рассмотрите возможность получения рублевой ипотеки или создания источника дохода в валюте кредита.`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyOptionsSection;